import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

export const UserInfosRequiredCard: FunctionComponent = () => {
  const navigate = useNavigate();

  const onGoToPersonalInfos = () => {
    navigate('/personal-information');
  };
  return (
    <Card>
      <CardContent>
        <Typography variant="body2">
          {
            'Veuillez compléter vos informations personnelles avant de continuer'
          }
        </Typography>
      </CardContent>
      <CardActions>
        <Button variant="contained" onClick={onGoToPersonalInfos}>
          Remplir mes informations
        </Button>
      </CardActions>
    </Card>
  );
};
